import Images from "../../../../config/Images";
import "./SignInNavBarBack.css";
import {useDispatch} from "react-redux";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";

interface SignInNavBarBackProps {
  screen: string
}

function SignInNavBarBack(props: SignInNavBarBackProps) {
  const {screen} = props;
  const dispatch = useDispatch();

  return (
    <div className={'sign-in-nav-back'}>
      <div className={'sign-in-nav-back-click'}>
        <i className="fa-solid fa-chevron-left"/>
        <p className={'sign-in-nav-back-text'} onClick={() => dispatch(updateSignUpScreen(screen))}>
          &nbsp; Back
        </p>
      </div>
      <img src={Images.benevvLogo} alt={"Benevv Logo"} className={"sign-in-nav-bar-back-benevv-logo"}
           onClick={() => dispatch(updateSignUpScreen(''))}/>
    </div>
  )
}

export default SignInNavBarBack;
